import { Component, OnInit, Renderer, ElementRef, HostListener, Input, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, RouterState } from '@angular/router';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { DOCUMENT, Title } from '@angular/platform-browser';
import { ToasterService } from 'angular2-toaster';
import { GlobalState } from '../../../global.state';
import { Constants } from '../../../app.constant';
import { ComParentChildService } from '../../../services/parent-child.service';
import { NotificationService } from "../../../services";
import { PendingChangesGuard } from '../../../pages/shared/services/pending-changes.guard';
import { DashboardService } from '../../../pages/shared/services/dashboard.service';
import { constants } from 'ngx-chips/core';
import { CustomerService } from '../../../pages/admin/components/customers/services/customer.service';
import { AuthenticationService } from '../../../services/index';
// import { CustomerService } from '../../../pages/admin/components/customers/services/customer.service';
import { PushNotificationService } from '../../../pages/shared/services/push-notification.service'
@Component({
  selector: 'ba-page-top',
  templateUrl: './baPageTop.html',
  styleUrls: ['./baPageTop.scss']
})
export class BaPageTop {

  public isScrolled: boolean = false;
  public isMenuCollapsed: boolean = false;
  public isPanasonicAdmin: boolean = ((!_.isEmpty(Constants.CurrentUserInfomations("userType"))) && ((Constants.CurrentUserInfomations("userType") != 'CUSTOMER_ADMIN')) && (Constants.CurrentCustomerInfomations("customerId"))) ? true : false;
  public hasNotNotificationAccess: boolean = false;
  public hasConfigAccess;
  public idCustomerAdmin: boolean = false;
  public loggedInUser = Constants.CurrentUserInfomations("fullName");
  public loggedInCustomer = Constants.CurrentCustomerInfomations("custName");
  public isAdvertisementEnabled = Constants.CurrentCustomerInfomations("isAdvertisementEnabled");
  public switchToAdButton;
  public isRequiredRefresh: boolean;
  public userAbbr;
  public notificationCount;
  public userType: string;
  subscription;
  subscriptionCallParent: Subscription;
  public timeSubscription;
  public timerSubscription;
  public dateModel;
  public time;
  public startTime;
  public interval;
  protected _onRouteChange: Subscription;
  public isBodyScrollable: boolean = true;
  public isClickedOnNotification: boolean = false;
  public isCustomerOnBoard: boolean = false;
  public isPDNEnabled: boolean = false;
  public PDNUrl: string;
  public sdnUrl: string;
  public loading: boolean = false;
  public customerInfo: any;
  public centerLogo;
  public leftLogo;
  public enableDesktopRegistration = Constants.CurrentEnvironmentProperties().enableDesktopRegistration;

  constructor(
    private router: Router,
    private _state: GlobalState,
    // private _customerService: CustomerService,
    private _dashboardService: DashboardService,
    private notificationService: NotificationService,
    private comparentchildservice: ComParentChildService,
    private _renderer: Renderer,
    private eRef: ElementRef,
    private _toasterService: ToasterService,
    private _customerService: CustomerService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private titleService: Title,
    private _authenticationService: AuthenticationService,
    private pushNotiService: PushNotificationService
  ) {
    this._state.subscribe('menu.activeLink', (activeLink) => {
      this.isRequiredRefresh = Constants.Var.isRequiredRefresh;
    });
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
    this.getUserAbbr(this.loggedInUser);
    //this.isCustomerOnBoard = Constants.CurrentCustomerInfomations('isCustomerOnboarded');
    this.leftLogo = Constants.CurrentBrandingDetails('leftNavLogo');
    this.centerLogo = Constants.CurrentBrandingDetails('centerLogo');
    this.comparentchildservice.on('change-brand-logo').subscribe(() => {
      this.getBrandingDetails();
    });

  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      this.isBodyScrollable = !this.isBodyScrollable;
      if (!this.isBodyScrollable && this.isClickedOnNotification) {
        this._renderer.setElementStyle(document.body, 'overflow', 'hidden');
        //this._renderer.setElementStyle(document.body, 'width', '1359px');
      } else {
        this.isBodyScrollable = true;
        this.isClickedOnNotification = false;
        this._renderer.setElementStyle(document.body, 'overflow', 'unset');
      }
    } else {
      this.isBodyScrollable = true;
      this.isClickedOnNotification = false;
      this._renderer.setElementStyle(document.body, 'overflow', 'unset');
    }
  }

  ngOnInit() {
    this.customerInfo = Constants.CurrentCustomerInfomations();
    this.subscription = this.comparentchildservice.on('call-page-top').subscribe(() => {
      this.resetCustomer();
    });
    this.userType = Constants.CurrentUserInfomations('userType');
    if (((this.userType == 'SUPER' || this.userType == 'CUST_REP_ADMIN') && Constants.CurrentCustomerInfomations("customerId") != null) || this.userType == 'CUSTOMER_ADMIN')
      this.idCustomerAdmin = true;
    else
      this.idCustomerAdmin = false;
    this.notificationService.notificationList.subscribe((msgList: Array<any>) => {
      if (msgList)
        this.notificationCount = msgList.length;
    });

    this.resetServerTimer();    // on the time of page-load and after login
    this.subscriptionCallParent = this.comparentchildservice.on('call-parent').subscribe(() => {
      this.resetServerTimer();  // on the time of switch user between panasonic_admin and customer_admin
      this.notificationService.resetList()
    });

    if ((this.userType == 'SUPER' || this.userType == 'CUST_REP_ADMIN') && Constants.CurrentCustomerInfomations("customerId") == null)
      this.hasConfigAccess = true;
    if (((this.userType == 'SUPER' || this.userType == 'CUST_REP_ADMIN') && Constants.CurrentCustomerInfomations("customerId") != null) || this.userType == 'CUSTOMER_ADMIN')
      this.hasConfigAccess = false;
    if (this.isPanasonicAdmin == false && this.userType != 'CUST_REP_ADMIN') {
      this.hasNotNotificationAccess = false;
    } else if (this.isPanasonicAdmin == false && this.userType == 'CUST_REP_ADMIN') {
      this.hasNotNotificationAccess = true;
    }
    else if (this.isPanasonicAdmin == true) {
      this.hasNotNotificationAccess = true;
    }
    else {
      this.hasNotNotificationAccess = false;
    }

    //this.isCustomerOnBoard = Constants.CurrentCustomerInfomations('isCustomerOnboarded');
    if (Constants.CurrentCustomerInfomations('isCustomerOnboarded') == null) {
      this.isCustomerOnBoard = true;
    } else {
      this.isCustomerOnBoard = Constants.CurrentCustomerInfomations('isCustomerOnboarded');
    }
    this.checkIfPDNEnabled();
    this.switchToAdButton = this.customerInfo ? (this.isPDNEnabled && this.isAdvertisementEnabled) : this.isPDNEnabled; 
  }

  resetServerTimer() {
    //if(Constants.CurrentCustomerInfomations('customerId') != null){
    this.refreshData();
    //}else{
    //this.time='';
    //if(this.interval){
    //  clearInterval(this.interval);
    //}       
    //}
  }

  public toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
    return false;
  }

  getUserAbbr(username) {
    let name = username.split(" ");
    name = name.map(el => el.charAt(0));
    this.userAbbr = name.join("");
    // console.log(this.userAbbr);
  }

  public scrolledChanged(isScrolled) {
    this.isScrolled = isScrolled;
  }

  public switchCustomerToPanasonicAdmin(customer: any, url) {
    //var a = this.router.navigate([url]);
    this.router.navigate([url],{ queryParams: { switchtoadmin: "yes" }}).then((res)=>{
      if(res == true)
      {
        //Constants.resetCostomerForPanasonicAdmin(customer);
        this.resetCustomer();
      }
      // do whatever you need after navigation succeeds
      
     // For Non-ssl if enabled
     if (!Constants.Var.sslOn) {
      this.pushNotiService.unsubscribe();
    }
    });
  }

  public resetCustomer() {
    this.customerInfo = Constants.CurrentCustomerInfomations();
    this.loggedInUser = Constants.CurrentUserInfomations("fullName");
    this.loggedInCustomer = Constants.CurrentCustomerInfomations("custName");
    this.isAdvertisementEnabled = Constants.CurrentCustomerInfomations("isAdvertisementEnabled");
    this.switchToAdButton = this.customerInfo ? (this.isPDNEnabled && this.isAdvertisementEnabled) : this.isPDNEnabled;
    this.userType = Constants.CurrentUserInfomations('userType');
    this.isPanasonicAdmin = ((!_.isEmpty(this.userType)) && ((this.userType != 'CUSTOMER_ADMIN')) && (Constants.CurrentCustomerInfomations("customerId"))) ? true : false;
    if (((this.userType == 'SUPER' || this.userType == 'CUST_REP_ADMIN') && Constants.CurrentCustomerInfomations("customerId") != null) || this.userType == 'CUSTOMER_ADMIN')
      this.idCustomerAdmin = true;
    else
      this.idCustomerAdmin = false;
    this.comparentchildservice.publish('call-parent');
    if ((this.userType == 'SUPER' || this.userType == 'CUST_REP_ADMIN') && Constants.CurrentCustomerInfomations("customerId") == null)
      this.hasConfigAccess = true;
    else
      this.hasConfigAccess = false;
    if (this.isPanasonicAdmin == false && this.userType != 'CUST_REP_ADMIN') {
      this.hasNotNotificationAccess = false;
    }
    else if (this.isPanasonicAdmin == false && this.userType == 'CUST_REP_ADMIN') {
      this.hasNotNotificationAccess = true;
    }
    else if (this.isPanasonicAdmin == true) {
      this.hasNotNotificationAccess = true;
    }
    else {
      this.hasNotNotificationAccess = false;
    }

    //this.isCustomerOnBoard = Constants.CurrentCustomerInfomations('isCustomerOnboarded');
    if (Constants.CurrentCustomerInfomations('isCustomerOnboarded') == null) {
      this.isCustomerOnBoard = true;
    } else {
      this.isCustomerOnBoard = Constants.CurrentCustomerInfomations('isCustomerOnboarded');
    }
  }

  private refreshData(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.timeSubscription = this._dashboardService.getCurrentServerTime().subscribe(data => {
      //this.time = this.convertFromTimestamp(data);
      this.startTime = data;
      this.subscribeToData()

    });
  }

  private subscribeToData(): void {
    //this.timerSubscription = Observable.timer(5000).first().subscribe(() => this.refreshData());
    let localTime = +Date.now();
    let timeDiff = +this.startTime - localTime;
    let realTime;
    let date;
    let hours, minutes, seconds
    this.interval = setInterval(() => {
      /*if(timeDiff > 3600000){
        this.refreshData();
      }else{*/
      realTime = +Date.now() + timeDiff;
      //date     = new Date(+realTime);        
      //hours    = date.getHours();          
      //minutes  = date.getMinutes();          
      //seconds  = date.getSeconds();          
      this.time = this.convertFromTimestamp(realTime)
      /*} */
    }, 1000);

  }

  public convertFromTimestamp(timestamp) {
    let dt: any;
    let amPm;
    dt = moment.unix(timestamp / 1000);
    amPm = dt.hour() >= 12 ? 'PM' : 'AM';
    //this.dateModel = dt.year() + "-" + ((dt.month()+1) < 10 ? ("0"+(dt.month()+1)):(dt.month()+1)) + "-" + (dt.date() < 10 ? ("0"+dt.date()): dt.date()) + " " + dt.hour() + ":" + dt.minute() + ":" + dt.seconds();// + " " + amPm;
    this.dateModel = (dt.hour() < 10 ? ("0" + dt.hour()) : dt.hour()) + ":" + (dt.minute() < 10 ? ("0" + dt.minute()) : dt.minute()) + ":" + (dt.seconds() < 10 ? ("0" + dt.seconds()) : dt.seconds());// + " " + amPm;
    return this.dateModel;
  }

  public redirectToPanConfig() { }

  public redirectToCustConfig() { }

  refreshRequired = function () {
    let customer = Constants.CurrentCustomerInfomations();
    this._dashboardService.getCustomersByKey(customer.customerId).subscribe(res => {
      Constants.Var.isRequiredRefresh = this.isRequiredRefresh = false;
      Constants.resetCostomerForPanasonicAdmin(res.result);
      this.comparentchildservice.publish('call-parent');
      location.href = "#/pages/dashboard";
      this.resetCustomer();
      // this.comparentchildservice.publish('call-page-top');
    },
      err => { });
  }

  closeRefresh = function () {
    this.isRequiredRefresh = false;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionCallParent.unsubscribe();
    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  hideScroll() {
    this.isClickedOnNotification = true;
  }

  checkIfPDNEnabled() {
    this.isPDNEnabled = Constants.PDNConfig('isPDNEnabled');
    this.PDNUrl = Constants.PDNConfig('PDNUrl');
  }
  public redirectToPdnUrl() {
    this.loading = true;
    let randomId = this._keygenerate('36');
    let param = {
      "randomId": randomId
    }
    this._dashboardService.sendPdnTokenPairing(param).subscribe(data => {
      if (data && data.result) {
        this.loading = false;
        // randomId = btoa(randomId);
        if (this.loggedInCustomer && this.sdnUrl != null) {
          window.open(this.sdnUrl + '?randomId=' + randomId, "_self");
        } else {
          window.open(this.PDNUrl + '?randomId=' + randomId, "_self");
        }

      }
    },
      err => {
        this.loading = false;
        if (_.isUndefined(err.error.result) && (!err.error.code)) {
          this._toasterService.pop('error', err.error.title, err.error.message);
          if (err.error.name == "401") {
            this.router.navigate(['/login']);
          }
        }
      });
  }
  _keygenerate = function (length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  getBrandingDetails() {
    let _data = {}, _apiUrl;
    if (Constants.CurrentCustomerInfomations("customerId")) {
      _apiUrl = this._customerService.getCustomerBrandingDetailsAfterImpersonate(Constants.CurrentCustomerInfomations("customerId"))
    } else {
      _apiUrl = this._authenticationService.getNonLoginBrandingData(window.location.origin)
    }

    _apiUrl.subscribe(res => {
      if (res.leftNavLogo) {
        // _data['leftNavLogo'] =  res.leftNavLogo;
        this.leftLogo = res.leftNavLogo; //Constants.CurrentBrandingDetails('leftNavLogo');
      }
      if (res.centerLogo) {
        // _data['centerLogo']= res.centerLogo;
        this.centerLogo = res.centerLogo; //Constants.CurrentBrandingDetails('centerLogo');
      }

      // if(!_.isEmpty(_data) && _data['centerLogo'] != null && _data['leftNavLogo'] != null){
      //   localStorage.removeItem('customerBrandingDetails');
      //   localStorage.setItem("customerBrandingDetails", JSON.stringify({'brandingDetails': _data }));
      // }

      // this.loginCenterImg = res.loginLogoCenter;
      // this.loginTopRightImg = res.loginLogoTopRight;
      if (res.favIconLogo.logoUrl) {
        this.setFavicon(res.favIconLogo.logoUrl);
      }else{
        this.setFavicon('/assets/default.ico');
      }
      // if(res.pageTitle != null){
      this.setTitle(res.pageTitle);
      // }
      // let customerBrandingDetails = JSON.parse(localStorage.getItem('customerBrandingDetails'));
      // customerBrandingDetails['brandingDetails']['sdn'] = res.sdn;
      // localStorage.setItem('customerBrandingDetails', JSON.stringify(customerBrandingDetails));
      if (res.sdn) {
        this.sdnUrl = res.sdn.adPlatformBrandUrl;
      }
    },
      err => {
        if (_.isUndefined(err.error.result) && (!err.error.code)) {
          this._toasterService.pop('error', err.error.title, err.error.message);
          if (err.error.name == "401") {
            this.router.navigate(['/login']);
          }
        } else {
          // this._error = err.error.message;
          // this.errorObj = err.error.result;
        }
      });
  }

  public setTitle(newTitle) {
    if (newTitle != ' ' && newTitle != '' && newTitle != null)
      this.titleService.setTitle(newTitle);
    // else
    //   this.titleService.setTitle('Panasonic - Digital Signage');
  }

  public setFavicon(faviconUrl) {
    this._document.getElementById('appFavicon').setAttribute('href', '');
    this._document.getElementById('appFavicon').setAttribute('href', faviconUrl)
    // console.log("vickrant logo ==> ", Constants.CurrentBrandingDetails('leftNavLogo'))
  }

  public redirectToQMSUrl() {
    var cu = JSON.parse(localStorage.getItem("currentUser"));
    window.open(Constants.Var.QMS_BASE_URL+'/'+this.customerInfo.customerUId+'/signLogin?org='+this.customerInfo.customerUId+'&auth='+cu.token, "_self");
  }

  public redirectToQMSUrl2() {
    this.loading = true;
    let randomId = this._keygenerate('36');
    let param = {
      "randomId": randomId
    }
    console.log("token save at QMS....")
    this._dashboardService.sendQMSTokenPairing(param).subscribe(data => {
      if (data && data.result) {
        this.loading = false;
        window.open(Constants.Var.QMS_BASE_URL+'/'+this.customerInfo.customerUId+'/login' + '?randomId=' + randomId, "_self");
      }
    },
      err => {
        this.loading = false;
        if (_.isUndefined(err.error.result) && (!err.error.code)) {
          this._toasterService.pop('error', err.error.title, err.error.message);
          if (err.error.name == "401") {
            this.router.navigate(['/login']);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/components/baPageTop/baPageTop.component.ts